import { render } from "./dashboard_soal.vue?vue&type=template&id=a1c88da2"
import script from "./dashboard_soal.vue?vue&type=script&lang=js"
export * from "./dashboard_soal.vue?vue&type=script&lang=js"

import "./dashboard_soal.vue?vue&type=style&index=0&id=a1c88da2&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__